/* Keep-on-page Add to Cart for Turbo (PAGE mode) */
(function () {
  function fmtLabel(btn) {
    const textEl = btn.querySelector('.text') || btn;
    return { el: textEl, base: btn.dataset.label || textEl.textContent.trim() };
  }

  async function addToCart(form, btn) {
    const { el, base } = fmtLabel(btn);
    btn.disabled = true;
    el.textContent = 'Agregando…';

    try {
      const fd = new FormData(form);
      // Enviar al carrito sin redirigir
      await fetch('/cart/add.js', {
        method: 'POST',
        body: fd,
        headers: { 'Accept': 'application/json' },
        credentials: 'same-origin'
      });

      // Actualiza contador del header
      const cart = await fetch('/cart.js', { credentials: 'same-origin' }).then(r => r.json());
      document.querySelectorAll('.cart_count').forEach(n => (n.textContent = cart.item_count));

      el.textContent = 'Agregado 👍🏻';
      setTimeout(() => { el.textContent = base; btn.disabled = false; }, 2000);
    } catch (err) {
      console.error(err);
      el.textContent = 'Error';
      setTimeout(() => { el.textContent = base; btn.disabled = false; }, 1200);
    }
  }

  // Intercepta SUBMIT del form (enter/submit nativo)
  document.addEventListener('submit', function (e) {
    const form = e.target;
    if (!form.matches('form[action*="/cart/add"]')) return;
    // Solo aplica en modo PAGE (incluye este script solo en PAGE)
    e.preventDefault(); e.stopImmediatePropagation();
    const btn = form.querySelector('button[name="add"], [type="submit"][name="add"]') || form.querySelector('button, [type="submit"]');
    addToCart(form, btn || form);
  }, true);


})();
